import { Card, Chip, IconButton, Stack, Tooltip } from "@mui/material"
import { isEnabled } from "lib/@components/feature"
import { If } from "lib/@components/switch"
import { TruncatedTypography } from "lib/@components/truncated-typography"
import Iconify from "minimals-template/components/Iconify"
import { FEATURE_FLAG_OPTIMISER_CONDITIONAL_TRADES } from "../../feature-flag-conditional-trades"
import { CustomSkillIndicator } from "./custom-skill-indicator"

export function SelectedSkillRow({ item, onConfigureRouting, onRemove }) {
    // Conditional trade routing and its entry points stay hidden until the feature flag is enabled
    const conditionalTradesOn = isEnabled(FEATURE_FLAG_OPTIMISER_CONDITIONAL_TRADES)
    const configured = conditionalTradesOn && (item.conditionalTrades || []).length > 0

    return (
        <Card
            data-cy="selected-skill-row"
            variant="outlined"
            sx={{
                px: 1.25,
                py: 0.75,
                borderColor: "divider",
                bgcolor: "background.paper",
                borderRadius: 1,
            }}
        >
            <Stack direction="row" alignItems="center" spacing={0.75}>
                <TruncatedTypography variant="subtitle2" sx={{ flex: 1, minWidth: 0 }}>
                    {formatLabel(item)}
                </TruncatedTypography>
                <If value={item.isCustomSkill}>
                    <CustomSkillIndicator rate={item.customHourlyRate} />
                </If>
                <If value={configured}>
                    <Chip
                        size="small"
                        label="Configured"
                        icon={<Iconify icon="mdi:source-branch" width={14} />}
                        sx={{ height: 22, "& .MuiChip-label": { px: 0.75 } }}
                    />
                </If>
                <If value={conditionalTradesOn}>
                    <Tooltip title="Configure routing">
                        <IconButton
                            data-cy="selected-skill-configure"
                            size="small"
                            onClick={handleConfigureRouting}
                            aria-label="Configure routing"
                        >
                            <Iconify icon="solar:settings-bold" width={18} />
                        </IconButton>
                    </Tooltip>
                </If>
                <Tooltip title="Remove skill">
                    <IconButton
                        data-cy="selected-skill-remove"
                        size="small"
                        color="error"
                        onClick={handleRemove}
                        aria-label="Remove skill"
                    >
                        <Iconify icon="solar:trash-bin-trash-bold" width={18} />
                    </IconButton>
                </Tooltip>
            </Stack>
        </Card>
    )

    function handleRemove() {
        onRemove(item.skillId)
    }

    function handleConfigureRouting() {
        onConfigureRouting(item)
    }
}

function formatLabel(skill) {
    if (skill.skillCode) return `${skill.skillName} (${skill.skillCode})`
    return skill.skillName
}
